import MemberMain from "../../components/payout-reports/MemberMain"

export const AllMemberReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <MemberMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}